import React from 'react';
import cx from 'classnames';

import { PurpleButton } from '@marketing/components/buttons';
import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import AssignmentsFeature from './assets/assignments_feature.png';
import ClassContentFeature from './assets/class_content_feature.png';
import CurriculumDetailsFeature from './assets/curriculum_details_feature.png';
import StarIcon from './assets/star_icon.svg';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l u-padding-V-xl" style={{ position: 'relative' }}>
      <SectionHeader
        reveal
        subtitle="Get extra structure and guidance from a 99th-percentile instructor."
        supertitle="Guided study"
        supertitleIcon={StarIcon}
        title="Magoosh ACT on-demand classes"
      />

      <div className={cx(styles.onDemandClassesContainer, 'd-flex flex-column gap-m gap-lg-l')}>
        <div className="d-flex flex-column flex-lg-row gap-m gap-lg-l">
          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of on-demand class content"
                loading="lazy"
                src={ClassContentFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                16+ Hours of On-Demand Classes
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Designed by a 99th-percentile instructor, our recorded classes break the ACT into manageable segments covering English, Math, Reading, Science, and Writing.
              </div>
            </div>
          </Card>

          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of assignments after each class"
                loading="lazy"
                src={AssignmentsFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                Homework Assignments
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Put your new knowledge to the test with a related homework assignment after each class.
              </div>
            </div>
          </Card>
        </div>

        <Card className="d-flex flex-1 flex-column gap-m">
          <div className="d-flex flex-column flex-lg-row gap-m">
            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                Curriculum Details
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Our eight classes cover specific strategies and techniques for every ACT question type.
              </div>
            </div>

            <div className="d-flex flex-1 justify-content-lg-end gap-s">
              <div>
                <PurpleButton href="/about-on-demand-classes">Learn More</PurpleButton>
              </div>

              <div>
                <PurpleButton href="/about-on-demand-classes#sample-clip">Watch Sample Clip</PurpleButton>
              </div>
            </div>
          </div>

          <div className="hidden-xs hidden-sm">
            <img
              alt="List of specific classes and topics"
              loading="lazy"
              src={CurriculumDetailsFeature}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};
